
// import BrandSlider from "../../components/brandslider/BrandSlider";
import ImageSlider from "../../components/imageslider/ImageSlider";
import "./home.scss";
import { Link } from "react-router-dom";

const Home = ()=>{
  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
  
  return (
    <>
    <ImageSlider/>
    <div className="home">
    {/* <h2 className="brand__title">brands we have worked for</h2>
        <BrandSlider/> */}
        <div className="workflow__wrapper">
          <Link to="/products/furnaces" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Furnace Manufacturing</h2>
              <p className="text">We build various types of furnaces ranging from gas fired furnaces, oil fired furnaces, walking beam furnaces, forges, to induction furnaces. Our furnaces can be custom manufactured to our clients specific requirements.</p>
            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730796075/induction_furnace_2_mviav8.jpg" alt="raydron_workflow" className="workflow__img" />
            </div>
          </div>
          </Link>
          <Link to="/products/metallurgicalsupplies" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Metallurgical Supplies</h2>
              <p className="text">We supply Metallurgical materials such as fire bricks, refractory cement, refractory mortar, premixed refractory mortar, ferrosilicon, ferrosilicon magnesium, ceramic fibre, silicon carbide graphite crucibles, insulation bricks, fire clay, silica moulding sand, etc.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730800984/metallurgical_banner_a4fgry.jpg" alt="raydron_workflow" className="workflow__img" />
            </div>
          </div>
          </Link>
          <Link to="/products" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Wire Rod Extruder Presses</h2>
              <p className="text">We build extruder presses for turning aluminium, copper or brass billets into wire rods which can be further drawn in a bench drawing machine to smaller diameters. Our extruder presses are built with affordability in mind.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730801984/extruder_banner_imajsj.jpg" alt="raydron_workflow" className="workflow__img" />
            </div>
          </div>
          </Link>
          <Link to="/products" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Hydrualic Power Systems</h2>
              <p className="text">We build hyrdualic power systems and machineries, providing hydraulic circuit design solutions and state-of-the-art control rountines for hydraulic systems.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730804862/hydraulic_banner_azwotq.jpg" alt="raydron_workflow" className="workflow__img" />
            </div>
          </div>
          </Link>
          <Link to="/products/foundryservices" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Foundry Services</h2>
              <p className="text">We run a foundry where we manufacture castings such as: Manhole Covers, Gully Gratings, Industrial Valves & Fittings, and other custom castings as required by our customers.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730805507/manhole_cover_banner_rsandq.jpg" alt="raydron_workflow" className="workflow__img" />
            </div>
          </div>
          </Link>

        </div>
    </div>
    </>
  )
}

export default Home